module.exports = __webpack_public_path__ + "static/img/cls-yj1.4b53934.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/cls-yj1.jpg
// module id = dVw+
// module chunks = 0